import fetchHelper from '../../utils/fetch-helper';

export default class ResultView {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.result-view');
        this.dealerUrl = this.el.dataset.dealerUrl;
        this.timer = this.el.querySelector('#finance-result-timer');

        this.views = {
            processing: this.el.querySelector('#finance-result-processing'),
            accepted: this.el.querySelector('#finance-result-accepted'),
            declined: this.el.querySelector('#finance-result-declined'),
            referred: this.el.querySelector('#finance-result-referred'),
            error: this.el.querySelector('#finance-result-error'),
        }

        this.timerCount = Number(this.timer.dataset.timer) || 60;
        this.counterSpan = this.views.processing.querySelector('.counter');
        this.counterSpan.innerHTML = this.timerCount;
        this.currentCount = this.timerCount;
        this.autoApprovedOrDenied = false;

        this.progressCircle = this.views.processing.querySelector('.progress-circle');
        this.progressValueBar = this.progressCircle.querySelector('.value-bar');
        this.progressStep = 360 / this.timerCount;
        this.progressStepCount = 0;
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    render(order) {
        this.order = order;

        this.update('processing');        
        this.setTimer();        
        this.setDealerLinks();
    }

    setTimer() {
        const triggerPoints = [55, 40, 25, 10];

        if(!this.timeInterval) {
            const self = this;

            this.timeInterval = setInterval(function() {
                if (self.currentCount >= 0) {
                    self.counterSpan.innerHTML = self.currentCount;
                    self.currentCount -= 1;
                    if(!self.autoApprovedOrDenied && triggerPoints.includes(self.currentCount)) {
                        self.getProposal();
                    }
                    
                    const rotation = self.progressStepCount*self.progressStep;
                    self.progressStepCount += 1;

                    self.progressValueBar.style.transform = `rotate(${rotation}deg)`;

                    if(rotation === 180) {
                        self.progressCircle.classList.add('over50');
                    }
                }
            }, 1000);

            setTimeout(function(){
                clearInterval(self.timeInterval)
                self.endTimer();
            }, self.timerCount*1000);
        }
    }

    async getProposal() {
        const req = await fetchHelper(`/gateway/api/finance-application-status?orderNumber=${this.order?.orderId}`);
        const res = await req.json();
        this.checkStatus(res);
    }

    checkStatus(res) {
        this.status = res.proposalStatus;

        if (this.status) {
            if (this.status === 'AP') {
                this.autoApprovedOrDenied = true;
                this.update('accepted');
            } else if (this.status === 'DC') {
                this.autoApprovedOrDenied = true;
                this.update('declined');
            }
        }
    }

    endTimer() {
        if(!this.autoApprovedOrDenied) {
            if(this.status === 'PR') {
                this.update('referred');
            } else {
                this.update('error');
            }                        
        }
    }

    async setDealerLinks() {        
        const dealerLinks = [...this.el.querySelectorAll('.dealer-cta')];

        const dealerCode = this.order?.dealer?.dealerCode;
        const result = dealerCode ? await window.HONDA.MyAccount2.client.getDealerDetails(this.dealerUrl, dealerCode) : null;
        const href = result?.dealer?.alias;

        if(href) {
            dealerLinks.forEach((dealerLink) => {
                dealerLink.setAttribute('href', href)
                dealerLink.classList.remove('hide');
            });
            
        } else {
            dealerLinks.forEach((dealerLink) => {
                dealerLink.classList.add('hide');
            });
        }
    }

    update(view) {
        const viewList = Object.keys(this.views).filter(v => v !== view);
        viewList.forEach(v => this.views[v].classList.add('hide'));

        this.views[view].classList.remove('hide');
    }
}
